import { useLayoutEffect } from 'react';

export const useAuxiliaryClassNameLayout = classNames => {
  const validClasses = classNames.filter(className => className);
  const body = document.querySelector('body');

  useLayoutEffect(() => {
    if (validClasses) {
      validClasses.forEach(cl => body.classList.add(cl));
    }

    return () => {
      const classList = body.classList;
      while (classList.length) {
        classList.remove(classList.item(0));
      }
    };
  }, [body.classList, validClasses]);

  return null;
};
